import { Path, isEmpty, isNil, pathOr } from 'ramda';

import { required } from './required';
import { TValidator } from './types';

export const ERR_REQUIRED = 'Required';

export const requiredWithoutOtherFields: (keys: Path[]) => TValidator = (keys) => (value, allValues) => {
  if (!keys.length) {
    return undefined;
  }

  const isAllResultsFalsy = keys.every((keyItem) => {
    const keyValue = pathOr(undefined, keyItem, allValues);

    return typeof keyValue === 'boolean' ? !keyValue : !isEmpty(keyValue) && !isNil(keyValue);
  });

  // if not all others required fields are falsy - should be not required
  if (!isAllResultsFalsy) {
    return undefined;
  }

  return required(value);
};
